// extracted by mini-css-extract-plugin
module.exports = {"container":"CryptoRewardsOrderDetailsField__container__XU-yK","label":"CryptoRewardsOrderDetailsField__label__VfCy2","value":"CryptoRewardsOrderDetailsField__value__Es8JL"};